<script setup lang="ts">
import { onMounted, ref } from 'vue'

import Badge from 'primevue/badge';
import Button from 'primevue/button';
import Popover from 'primevue/popover';

import { announcementsStore } from '@/stores/announcements'

const announcements = announcementsStore()
const popover = ref()

const TYPE_ICONS: Record<string, string> = {
  feature: 'pi pi-sparkles text-emerald-600',
  bug: 'pi pi-wrench text-amber-600',
}
const DEFAULT_TYPE_ICON = 'pi pi-info-circle text-slate-500'

function typeIcon(type: string) {
  return TYPE_ICONS[type] || DEFAULT_TYPE_ICON
}

onMounted(() => {
  announcements.fetchAnnouncements()
})

function toggle(event: Event) {
  popover.value.toggle(event)
  announcements.markAllSeen()
}
</script>

<template>
  <div class="relative">
    <Button
      icon="pi pi-bell"
      rounded
      class="text-slate-700 bg-white border border-slate-700"
      style="width: 2rem; height: 2rem; padding: 0;"
      @click="toggle"
    />
    <Badge
      v-if="announcements.unreadCount > 0"
      severity="info"
      class="absolute top-0 bottom-0 left-1 pointer-events-none text-[0.6rem] min-w-2 h-2 leading-none px-1"
    />
  </div>

  <Popover ref="popover">
    <div class="flex flex-col w-72 max-h-96 overflow-y-auto overflow-x-hidden">
      <div v-if="announcements.announcements.length === 0" class="text-sm text-slate-500 px-4 py-3">
        No announcements
      </div>
      <div
        v-for="(item, i) in announcements.announcements"
        :key="i"
        class="flex flex-col gap-1 px-4 py-3 hover:bg-slate-50 border-b border-slate-100 last:border-b-0"
      >
        <div class="flex items-center justify-between gap-2 text-xs">
          <!-- <i :class="typeIcon(item.type)"></i> -->
          <span class="text-slate-400">{{ item.date }}</span>
        </div>
        <div class="text-sm text-slate-700">{{ item.message }}</div>
        <a
          v-if="item.link"
          :href="`https://the-odds-api.com${item.link}`"
          target="_blank"
          rel="noopener noreferrer"
          class="flex items-center gap-1 text-xs text-blue-600 hover:underline self-start"
        >
          Details
          <i class="pi pi-external-link text-[0.5rem]"></i>
        </a>
      </div>
    </div>
  </Popover>
</template>
